import React from "react"
import withStyles from "@material-ui/core/styles/withStyles"
import Helmet from "react-helmet"

import MainAppChrome from "../../chrome/MainAppChrome"
import Hero from "../../../components/ui-Hero"
import HeroTitle from "../../../components/ui-HeroTitle"
import HaloPicture from "../../../components/HaloPicture"
import PageSection from "../../../components/ui-PageSection"
import { Container, Row, Col } from "Grid"
import { Text, TextList, Title, Header, Headline } from "Text"

import Button from "@material-ui/core/Button"

import BioSection from "../../BioSection"
import SupportGroupBanner from "../../SupportGroupBanner"
import ServicePaymentOptions from "../../ServicePaymentOptions"
import ServiceCallInstructions from "../../ServiceCallInstructions"
import CancellationPolicy from "../../CancellationPolicy"
import StructuredData from "../../../components/StructuredData"

import { SCHEDULE_URL, ASK_URL } from "../../../lib/urls"

import breastfeedingHaloImage from "../../../../static/images/breastfeeding-halo.jpg"

const styleSheet = theme => {
  return {
    heroPicture: {
      margin: [0, theme.spacing(5)],

      [theme.breakpoints.down("xs")]: {
        margin: theme.spacing(3),
      },

      [theme.breakpoints.down("sm")]: {
        maxWidth: theme.spacing(44),
      },
    },

    scheduleButton: {
      margin: theme.spacing(),

      "&:first-child": {
        marginLeft: 0,
      },

      [theme.breakpoints.down("xs")]: {
        display: "block",
        flex: [1, 0, "100%"],
      },
    },

    scheduleSection: {
      marginTop: theme.spacing(3),
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "center",
    },

    pricingWell: {
      marginTop: theme.spacing(5),
    },
  }
}

const structuredData = {
  "@context": "http://schema.org/",
  "@type": "Service",
  name: "Postpartum Consultation",
  description:
    "This is a 2 hour consultation for mothers (and their partners) that need breastfeeding guidance. You may feel you lack milk, have pain when nursing, or face other challenges; I can help.",
  offers: {
    "@type": "Offer",
    priceCurrency: "USD",
    price: "220.00",
    url: "https://jalactation.com/breastfeeding-support/in-home-consultation",
  },
}

function PostpartumConsultation({ classes }) {
  return (
    <MainAppChrome>
      <Helmet>
        <title>Infant Feeding Consult</title>
        <meta
          name="description"
          content="
              This is a 2 hour consultation for
              families that need infant feeding or lactation guidance.
              You may feel you lack milk, have pain when nursing, or face other
              challenges; I can help.
              "
        />
      </Helmet>
      <Hero>
        <Container wide>
          <Row alignItems="center">
            <Col sm={12} md={5} lg={4}>
              <HaloPicture image={breastfeedingHaloImage} className={classes.heroPicture} />
            </Col>
            <Col xs={12} md={7} lg={8}>
              <HeroTitle
                title="Infant Feeding Consult"
                subTitle="
              This is a 2 hour consultation for
              families that need infant feeding or lactation guidance.
              You may feel you lack milk, have pain when nursing, or face other
              challenges; I can help.
              "
              />

              <Container wide flex className={classes.scheduleSection}>
                <Button
                  color="primary"
                  variant="contained"
                  href={SCHEDULE_URL}
                  target="_blank"
                  className={classes.scheduleButton}
                >
                  Schedule help
                </Button>
                <Button color="primary" href={ASK_URL} className={classes.scheduleButton}>
                  Ask a question
                </Button>
                <Button color="primary" href="#pricing" className={classes.scheduleButton}>
                  Pricing
                </Button>
                <StructuredData data={structuredData} />
              </Container>
            </Col>
          </Row>
        </Container>
      </Hero>

      <PageSection gutterTop gutterBottom>
        <Container wide>
          <Row>
            <Col md={7} xs={12}>
              <Headline paragraph>What can you expect during your consultation?</Headline>

              <TextList>
                <li>Oral exam to assess baby's mouth</li>
                <li>Feeding position and latch are assessed</li>
                <li>
                  Baby is weighed before and after the feeding to measure the amount of breast milk
                  consumed
                </li>
                <li>Demonstrate and develop a personalized Plan of Care</li>
              </TextList>

              <Text paragraph>
                Following your visit, I will call or email you within 48 hours to see how you and
                baby are doing. I will send a report to your primary care provider(s) summarizing
                the consultation.
              </Text>

              <div className={classes.pricingWell} id="pricing">
                <Title paragraph>Pricing</Title>
                <Row>
                  <Col xs={12} sm={6}>
                    <Header paragraph>In Your Home</Header>
                    <Text paragraph>$230 for the first visit and $170 for follow ups.</Text>
                  </Col>
                  <Col>
                    <Header paragraph>
                      At <a href="/contact">My Office</a>
                    </Header>
                    <Text paragraph>$165 for the first visit and $85 for follow ups.</Text>
                  </Col>
                </Row>

                <ServicePaymentOptions />
                <CancellationPolicy />
              </div>
            </Col>
            <Col md={1} xs={12} />
            <Col lg={3} md={4} xs={12}>
              <ServiceCallInstructions />
            </Col>
          </Row>
        </Container>
      </PageSection>
      <BioSection />
      <SupportGroupBanner />
    </MainAppChrome>
  )
}

export default withStyles(styleSheet)(PostpartumConsultation)
